import {setGeoLocation} from '@/lib/locale/geoLocaltion'
import {isSupportedLocale, isUserSelectedLocale, localeAtom} from '@/lib/locale/locale'
import {fetchLocalization} from '@/services/localeService'
import {logError} from '@/utils/logger'

export default memo(function LocaleUpdater() {
  const setLocale = useSetAtom(localeAtom)

  fetchLocalization()
    .then(data => {
      setGeoLocation(data.geo_location)
      if (!isUserSelectedLocale()) {
        if (isSupportedLocale(data.locale)) {
          setLocale(data.locale)
          return
        }

        throw new Error('Unsupported locale', {cause: data})
      }
    })
    .catch(error => {
      logError(error)
    })

  return null
})
